const firebaseErrorMessages: { [key: string]: string } = {
  'auth/invalid-credential': 'The provided credential is invalid. Please try again.',
  'auth/user-not-found': 'No user found with the provided credentials.',
  'auth/wrong-password': 'Incorrect password. Please try again.',
  'auth/invalid-email': 'The email address is invalid.',
  'auth/email-already-in-use': 'This email is already in use. Please use a different one.',
  'auth/weak-password': 'The password is too weak. Please use a stronger password.',
};

export default firebaseErrorMessages;
